import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  aboutUsState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const aboutUsSlice = createSlice({
  name: 'aboutUs',
  initialState: initialState,
  reducers: {
    getAboutUsRequest: (state: any) => {
      state.aboutUsState.isFetching = true
      state.aboutUsState.isFetched = false
      state.aboutUsState.isFailed = false
      state.aboutUsState.errorMessage = ''
    },
    getAboutUsSuccess: (state: any, action) => {
      state.aboutUsState.isFetching = false
      state.aboutUsState.isFetched = true
      state.aboutUsState.item = action.payload.item
    },
    getAboutUsFailure: (state: any, action) => {
      state.aboutUsState.isFetching = false
      state.aboutUsState.isFetched = true
      state.aboutUsState.isFailed = true
      state.aboutUsState.errorMessage = action.payload.errorMessage
    },
  },
})

export const { getAboutUsRequest, getAboutUsSuccess, getAboutUsFailure } =
  aboutUsSlice.actions

export default aboutUsSlice.reducer
